

let consts = {
  fontInfo: [
    { id: "caslon", name: "Caslon", filename: "//dd36vwzbditnx.cloudfront.net/assets/Caslon-Bold-13eb02c6ef78111b397a421baf0782cf65129b8a4612c9dfc6930ef134a96659.ttf"},
    { id: "ornate", name: "Ornate", filename: "//dd36vwzbditnx.cloudfront.net/assets/Ornate-a7b1a8d309269c957a9abc4bda560cdd6871594675f7558668a4fdbde3dda0ac.ttf"},
    { id: "rustic", name: "Rustic", filename: "//dd36vwzbditnx.cloudfront.net/assets/Rustic-a7350dae65c7c40538c427930ba17bfe681c0e8f5a6d8b0ff0184cf03aaf7991.ttf"},
    { id: "se-airfoil-script", name: "Se Airfoil Script", filename: "//dd36vwzbditnx.cloudfront.net/assets/SE_AirfoilScript-3c14998d642668d9d976299688fecf1ab9195a6c771d427298350d4a9b6baead.ttf"},
    { id: "se-alako", name: "SE Alako", filename: "//dd36vwzbditnx.cloudfront.net/assets/SE_Alako-94e6d96ce8f248d1474f819cda25988ac7a0f26061ee0f4220510a23ab0e205c.ttf"},
    { id: "se-arial", name: "SE Arial", filename: "//dd36vwzbditnx.cloudfront.net/assets/SE_Arial-a2e822de2fa2c20c5e83ff54146d6744865a0e0924ed45b55d374438b1a03281.ttf"},
    { id: "se-arriare-garde",  name: "SE Arriäre Garde", filename: "//dd36vwzbditnx.cloudfront.net/assets/SE_ArrireGarde-d3a0fe549d59bd71e2044b23c462f300a4a742fbb77ac8b06b0b098bda9ae43e.ttf"},
    { id: "se-artistik",  name: "SE Artistik", filename: "//dd36vwzbditnx.cloudfront.net/assets/SE_Artistik-e2d4eb298ea1701839897bad1d0468f856f3f7017005a7beac2ad1fe7ea73af7.ttf"},
    { id: "se-cowboys", name: "SE Cowboys", filename: "//dd36vwzbditnx.cloudfront.net/assets/SE_Cowboys-db69cf87a46dea6b839e3cab908b19ff3f418b90157dac13372f729e6c5ae001.ttf"},
    { id: "se-dali", name: "SE Dali", filename: "//dd36vwzbditnx.cloudfront.net/assets/SE_Dali-1cb57b1969577c4368a4e7970bfe36923b5bfbe4b0865f2ad109f975ab5e0f8c.ttf"},
    { id: "se-escapade", name: "SE Escapade", filename: "//dd36vwzbditnx.cloudfront.net/assets/SE_Escapade-9df4cf19fc104d09b4b43623d84d5a715c3ad0af9b493cf905a6429026a85c8f.ttf"},
    { id: "se-futura-md-bt", name: "SE Futura Md BT", filename: "//dd36vwzbditnx.cloudfront.net/assets/SE_FuturaMdBT-BoldItalic-2164afb4fc016066173fb5fd54cfe7048854d2bec8377479ac2171a7282e650c.ttf"},
    { id: "se-imperatorii", name: "SE imperatorII", filename: "//dd36vwzbditnx.cloudfront.net/assets/SE_imperatorII-3b9e7e3fa05ff86c4c614bd422a4c4a00d84a816cec5841859162c8214f59f3e.ttf" },
    { id: "se-military", name: "SE Military", filename: "//dd36vwzbditnx.cloudfront.net/assets/SE_military-acf4037daf02f9a367bd322b17aff5c90a08a7f2656722278c9cd28761ec19be.ttf"},
    { id: "se-monogram", name: "SE Monogram", filename: "//dd36vwzbditnx.cloudfront.net/assets/SE_Monogram-81c7b02ad32351c622164e3ee94d832ad632f8ce77e49d414e2e3bb12b1c82c7.ttf"},
    { id: "se-old-english", name: "SE Old English", filename: "//dd36vwzbditnx.cloudfront.net/assets/SE_OldEnglish-e915e27d811698b484688221206066e32ddb3b68a5d7b96186d036671cd1c254.ttf"},
    { id: "se-old-newsprint", name: "SE Old Newsprint", filename: "//dd36vwzbditnx.cloudfront.net/assets/SE_OldNewsprint-c73ac7bbc18202aa3b20b333a4e406c778bba1dc99b85a0358bc0a5d703d8452.ttf"},
    { id: "se-papyrus", name: "SE Papyrus", filename: "//dd36vwzbditnx.cloudfront.net/assets/SE_Papyrus-3a1962bc3f8c7aec499e74b40f8ab0912faffd8144827b8e42bbc368daa37b7e.ttf"},
    { id: "se-parking-lot", name: "SE Parking Lot", filename: "//dd36vwzbditnx.cloudfront.net/assets/SE_Parking_Lot-8c25165b05b2f71a357125402f156a3a03976814f4b53d7f81fe2d437d6c55e7.ttf"},
    { id: "se-pristina", name: "SE Pristina", filename: "//dd36vwzbditnx.cloudfront.net/assets/SE_Pristina-06316f51b4059ba8754774513132e5421d6f0cbb1fd23ca958dd44712a1ee8ae.ttf"},
    { id: "se-simple-script", name: "SE Simple Script", filename: "//dd36vwzbditnx.cloudfront.net/assets/SE_SimpleScript-c3e5fa2d9141bfbb4cf99638e14913f66740cfd95378bdfe0f7dc327ab79100a.ttf"},
    { id: "se-times-new-roman", name: "SE Times_New_Roman", filename: "//dd36vwzbditnx.cloudfront.net/assets/SE_Times_New_Roman-ec745ee09b46ce4e03ed891373d86283313e2b0765f06828509b2df8360b2a01.ttf"},
    { id: "se-whimsical", name: "SE Whimsical", filename: "//dd36vwzbditnx.cloudfront.net/assets/SE_Whimsical-fe07e518a1c30b4fc74819b8d116515d45c4a5c0b7153036ddd9b07e7ca17bbc.ttf"},
    { id: "se-girls-are-weird", name: "SE Girls Are Weird", filename: "//dd36vwzbditnx.cloudfront.net/assets/SE_GirlsAreWeird-c0080dc5e242ace5e96f34969fe32544319572ba0b00aaf6b5eb66ea464cf9b5.ttf"},
    { id: "se-script", name: "SE Script", filename: "//dd36vwzbditnx.cloudfront.net/assets/SEScript-93dbffeb4feedde4b9289e41b66abcb0cb052190630eaf0dd94a378c73222312.ttf"},
    { id: "se-sticks", name: "SE Sticks", filename: "//dd36vwzbditnx.cloudfront.net/assets/SESticks-41f767eb26a6e8da8496fc82631359779ca5b52660f9693f25653e2926b5cffe.ttf"},
    { id: "se-export", name: "SE Export", filename: "//dd36vwzbditnx.cloudfront.net/assets/StencilExport-445b2354c0d4e62a456e998cee0612efbab2e83744bcf7873d4475c0488a0b00.ttf"},
    { id: "stencil", name: "Stencil", filename: "//dd36vwzbditnx.cloudfront.net/assets/Stencil-83274d818cab94f698ae0f9f7ea2b3e0844819fe476f244581bb11ab8cad128c.ttf"}
  ],
  material: [
    {
      text: 'Light-Duty 7 mil film',
      value: 'Light-Duty 7 mil film',
      dimension_w: [
        12, 18, 24, 30, 36, 42, 48, 54, 60, 66, 72, 78, 84, 90, 96, 102, 108,
        114, 120, 132, 144, 156, 168, 180, 192, 204, 216, 228, 240, 252, 264,
        276, 288, 300, 312, 324, 336, 348, 360
      ],
      dimension_h: [12,18,24,36,41,51]
    },
    {
      text: 'Medium-Duty 10 mil film<br><small>Decorative or general use. Reusable.</small>',
      value: 'Medium-Duty 10 mil film',
      dimension_w: [
        12, 18, 24, 30, 36, 42, 48, 54, 60, 66, 72, 78, 84, 90, 96, 102, 108,
        114, 120, 132, 144, 156, 168, 180, 192, 204, 216, 228, 240, 252, 264,
        276, 288, 300, 312, 324, 336, 348, 360
      ],
      dimension_h: [12,18,24,36,41,51,72]
    },
    {
      text: 'Adhesive-Backed 7 mil Plastic<br><small>Decorative or industrial use plastic with peel-off backing. Reusable.</small>',
      value: 'Adhesive-Backed 7 mil Plastic',
      dimension_w: [
        12, 18, 24, 30, 36, 42, 48, 54, 60, 66, 72, 78, 84, 90, 96, 102, 108,
        114, 120, 132, 144, 156, 168, 180, 192, 204, 216, 228, 240, 252, 264,
        276, 288, 300, 312, 324, 336, 348, 360
      ],
      dimension_h: [12,18,27]
    },
    {
      text: "UltraFlex&trade; 60 mil Industrial Grade<br><small>1/16&trade; thick durable, flexible LLDPE for parking lots, athletic fields and industrial jobs. Won't blow away during outdoor applications. Reusable. Best for horizontal applications.  Not recommended for fonts less than 4 inches in height.</small>",
      value: 'UltraFlex&trade; 60 mil Industrial Grade',
      dimension_w: [
        18, 24, 30, 36, 42, 48, 60, 72, 84, 96, 108, 119, 132, 144, 156, 168,
        180, 192, 204, 216, 228, 240, 252, 264, 276, 288, 300, 312, 324, 336,
        348, 360
      ],
      dimension_h: [18,24,36,48,60,71]
    },
    {
      text: "Duraflex; 125 mil Contractor Grade",
      value: "Duraflex; 125 mil Contractor Grade",
      dimension_w: [
        18, 24, 30, 36, 42, 48, 60, 72, 84, 96, 108, 120, 132, 144, 156,
        168, 180, 192, 204, 216, 228, 240, 252, 264, 276, 288, 300, 312,
        324, 336, 348, 360
      ],
      dimension_h: [18, 24, 36, 48, 60, 71]
    }
  ],
  product_material_variant: null,
  materialLetter: [
    {
      text: 'Standard-Duty 7 mil film<br><small>Decorative or general use. Reusable.</small>',
      value: '7mil Standard',
      maxHeight: 22
    },
    {
      text: 'Medium-Duty 10 mil film<br><small>Decorative or general use. Reusable.</small>',
      value: '10mil Medium',
      maxHeight: 72
    },
    {
      text: 'Heavy-Duty 14 mil film<br><small>Decorative or general use. Reusable.</small>',
      value: '14mil Heavy',
      maxHeight: 72
    },
    {
      text: 'Adhesive-Backed 7 mil Plastic<br><small>Decorative or industrial use plastic with peel-off backing. Reusable.</small>',
      value: '7mil Adhesive Vinyl',
      maxHeight: 22
    },
    {
      text: "UltraFlex&trade; 60 mil Industrial Grade<br><small>1/16&trade; thick durable, flexible LLDPE for parking lots, athletic fields and industrial jobs. Won't blow away during outdoor applications. Reusable. Best for horizontal applications.  Not recommended for fonts less than 4 inches in height.</small>",
      value: '60mil LLDPE',
      maxHeight: 72
    }
  ],
  __ratioHeight: 1.5,
  _svg: '',
  _svg_w: 0,
  _svg_h: 0,
  _font: null,
  _letters: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z", "0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "!", "$", "&", ",", ".", "?", "-"]
}

export const STENCILCONST = consts
